import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class MaintenanceOrderEditComponent extends React.Component {

	componentDidMount() {
		this.props.findAllCustomerIds();
	}

	onSubmit() {

		if (Date.parse(this.props.order.get('sOrderDate')) == NaN || Date.parse(this.props.order.get('sDueDate')) == NaN) {
			alert('日期格式錯誤或未填寫日期');
		} else {
			this.props.editOrder();
		}
	}

	render() {
		let showNote = (this.props.showNote) ? 'none' : 'none';

		return (
			<div>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<FieldGroup
							id="orderId"
							type="text"
							label="訂單編號"
							value={this.props.order.get('orderId')}
							disabled={!this.props.forInsert}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('orderId')}
						/>
						<DropDownInput id="customerId"
							label="客戶名稱"
							required="true"
							options={this.props.allCustomerIds.toJS()}
							selected={[{ label: this.props.order.get('customerName'), value: this.props.order.get('customerId') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
								this.props.setValue('customerName', label);
							}}
							validation={this.props.orderValidation.get('customerId')}
						/>
						<FieldGroup
							id="caseOfficer"
							type="text"
							label="訂貨人"
							value={this.props.order.get('caseOfficer')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('caseOfficer')}
						/>
						<FieldGroup
							id="orderDate"
							type="date"
							label="訂單日期"
							value={this.props.order.get('sOrderDate')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue('sOrderDate', value);
							}}
							validation={this.props.orderValidation.get('sOrderDate')}
						/>
						<FieldGroup
							id="dueDate"
							type="date"
							label="交期"
							value={this.props.order.get('sDueDate')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue('sDueDate', value);
							}}
							validation={this.props.orderValidation.get('sDueDate')}
						/>
						<FieldGroup
							id="caseNumber"
							type="text"
							label="案號"
							value={this.props.order.get('caseNumber')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('caseNumber')}
						/>
						<FieldGroup
							id="caseName"
							type="text"
							label="用途/標案名稱"
							value={this.props.order.get('caseName')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('caseName')}
						/>
						<FieldGroup
							id="sales"
							type="text"
							label="承辦業務"
							value={this.props.order.get('sales')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('sales')}
						/>
						<FieldGroup
							id="noteDisplay"
							type="text"
							label="備註"
							value={this.props.order.get('noteDisplay')}
							placeholder=""
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.orderValidation.get('noteDisplay')}
							componentClass="textarea"
							rows="10"
						/>
						<div style={{ display: showNote }}>
							<FieldGroup
								id="note"
								type="text"
								label="備註 (機密資料)"
								value={this.props.order.get('note')}
								placeholder=""
								onChange={(id, value) => {
									this.props.setValue(id, value);
								}}
								validation={this.props.orderValidation.get('note')}
								componentClass="textarea"
								rows="3"
							/>
						</div>
					</Col>
				</Row>
				<table style={{ width: '90%' }}>
					<tbody>
						<tr>
							<td style={{ textAlign: 'right' }} >
								<Button onClick={(event) => {
									this.onSubmit();
								}} bsStyle="info">
									新增清洗維修訂單
							</Button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceOrderEditComponent.jsx